// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"28a6de8d","453":"fe7208d6"}[chunkId] + ".chunk.js";
};